<template>
  <div class="trip-block">
    <ul class="trip-list" v-if="trips.length > 0">
      <li
        class="trip-item"
        v-for="(trip, index) in trips"
        :key="index"
        @click="goToTripDetails(trip.id)"
      >
        <!-- Карточка рейса -->
        <div class="trip-card">
          <!-- Заголовок карточки -->
          <div class="card-header">
            <div class="card-title-section">
              <h3 class="trip-title" v-if="trip.name">
                <span class="title-text">Рейс #{{ trip.id }}:</span>
                {{ trip.name }}
              </h3>
              <span
                class="trip-status"
                :style="{
                  'background-color': tripStore.tripStatusColor(
                    trip.status
                  ),
                }"
              >
                {{ tripStore.formatTripStatus(trip.status) }}
              </span>
            </div>
          </div>

          <!-- Основная информация -->
          <div class="card-content">
            <!-- Блок статуса и времени -->
            <div class="info-card main-info">
              <div class="card-section-header">
                <div class="section-icon">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="#000"
                      stroke-width="2"
                    />
                    <path
                      d="M12 6V12L16 14"
                      stroke="#000"
                      stroke-width="2"
                    />
                  </svg>
                </div>
                <h4 class="section-title">Статус и время</h4>
              </div>

              <div class="card-section-content">
                <div class="status-display">
                  <div class="main-info-row">
                    <span class="info-label">Завершено:</span>
                    <span class="info-value">
                      {{
                        trip.status == "completed" &&
                        trip.actual_finished_at
                          ? formatDateAndTime(trip.actual_finished_at)
                          : "—"
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Блок транспорта и водителей -->
            <div class="transport-drivers-grid">
              <!-- Транспорт -->
              <div class="info-card" v-if="trip.vehicles.length > 0">
                <div class="card-section-header">
                  <div class="section-icon">
                    <svg
                      class="vehicle-svg"
                      fill="#000000"
                      height="22px"
                      width="22px"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                      transform="matrix(-1, 0, 0, 1, 0, 0)"
                    >
                      <path
                        d="m480.6,53h-253.2c-11.3,0-20.4,9.1-20.4,20.4v85.7h-73.6c-5.8,0-11.4,2.5-15.3,6.9l-102,115c-3.3,3.7-5.1,8.5-5.1,13.5v96.5c0,11.3 9.1,20.4 20.4,20.4h31.2c9.9,27.8 36.4,47.7 67.6,47.7 31.2,0 57.7-19.9 67.6-47.7h29.5 93.5c9.9,27.8 36.4,47.7 67.6,47.7s57.7-19.9 67.6-47.7h24.6c11.3,0 20.4-9.1 20.4-20.4v-317.6c0-11.3-9.1-20.4-20.4-20.4zm-350.3,365.2c-17,0-30.9-13.8-30.9-30.8 0-17 13.9-30.8 30.9-30.8 17,0 30.9,13.8 30.9,30.8-0.1,17-13.9,30.8-30.9,30.8zm0-102.4c-33.7,0-62.1,23.4-69.7,54.7h-8.7v-68.4l90.7-102.3h64.4v170.7h-7c-7.7-31.3-36-54.7-69.7-54.7zm258.1,102.4c-17,0-30.9-13.8-30.9-30.8 0-17 13.9-30.8 30.9-30.8 17,0 30.9,13.8 30.9,30.8 5.68434e-14,17-13.9,30.8-30.9,30.8zm71.8-47.7h-2.1c-7.6-31.4-36-54.7-69.7-54.7s-62.1,23.4-69.7,54.7h-71v-191-85.7h212.4v276.7z"
                      />
                    </svg>
                  </div>
                  <h4 class="section-title">Транспорт</h4>
                  <span class="section-count">
                    {{ trip.vehicles.length }}
                  </span>
                </div>

                <div class="card-section-content">
                  <div class="entities-list">
                    <div
                      class="entity-card"
                      v-for="vehicle in trip.vehicles"
                      :key="vehicle.id"
                    >
                      <div class="entity-header">
                        <span
                          class="entity-role"
                          v-if="getVehicleRole(trip, vehicle.id)"
                        >
                          {{ getVehicleRole(trip, vehicle.id) }}
                        </span>
                      </div>
                      <div class="entity-details">
                        <div class="detail-item">
                          <span class="detail-label">Модель:</span>
                          <span class="detail-value">
                            {{ vehicle.model }}
                          </span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Номер:</span>
                          <span class="detail-value">
                            {{ vehicle.registration_number }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Водители -->
              <div class="info-card" v-if="trip.drivers.length > 0">
                <div class="card-section-header">
                  <div class="section-icon">
                    <svg
                      class="driver-svg"
                      viewBox="0 0 64 64"
                      width="20px"
                      height="20px"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke-width="5"
                      stroke="#000000"
                      fill="none"
                    >
                      <circle cx="32" cy="18.14" r="11.14" />
                      <path
                        d="M54.55,56.85A22.55,22.55,0,0,0,32,34.3h0A22.55,22.55,0,0,0,9.45,56.85Z"
                      />
                    </svg>
                  </div>
                  <h4 class="section-title">Водители</h4>
                  <span class="section-count">
                    {{ trip.drivers.length }}
                  </span>
                </div>

                <div class="card-section-content">
                  <div class="entities-list">
                    <div
                      class="entity-card"
                      v-for="driver in trip.drivers"
                      :key="driver.id"
                    >
                      <div class="entity-header">
                        <span
                          class="entity-role"
                          v-if="getDriverRole(trip, driver.id)"
                        >
                          {{ getDriverRole(trip, driver.id) }}
                        </span>
                      </div>
                      <div class="entity-details">
                        <div class="detail-item">
                          <span class="detail-label">Имя:</span>
                          <span class="detail-value">
                            {{ formatDriverName(driver) }}
                          </span>
                        </div>
                        <div class="detail-item" v-if="driver.phone">
                          <span class="detail-label">Телефон:</span>
                          <span class="detail-value">
                            {{ driver.phone }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Сообщение если нет транспорта и водителей -->
              <div
                class="info-card empty-card"
                v-if="
                  trip.vehicles.length === 0 &&
                  trip.drivers.length === 0
                "
              >
                <div class="empty-state">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 12H16M3 12H5M19 12H21M12 3V5M12 19V21M18.364 5.63604L16.9497 7.05025M7.05025 16.9497L5.63604 18.364M18.364 18.364L16.9497 16.9497M7.05025 7.05025L5.63604 5.63604"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  <span>Транспорт и водители не указаны</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Мета информация -->
          <div
            class="card-footer"
            v-if="trip.created_at || trip.updated_at"
          >
            <MetaTime
              :created-at="trip.created_at"
              :updated-at="trip.updated_at"
            />
          </div>
        </div>
      </li>
    </ul>

    <div class="no-data" v-else>Рейсов не найдено</div>

    <!-- Пагинация -->
    <pagination-component
      v-if="tripStore.pagination.pages > 1"
      :page="tripStore.pagination.page"
      :pages="tripStore.pagination.pages"
      :series="tripStore.pagination.series"
      :route-query="currentRouteQuery"
    />
  </div>
</template>

<script>
import MetaTime from "@/components/Meta/MetaTime.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import { useTripStore } from "@/stores/tripStore";
import { formatDateAndTime } from "@/utils/dateUtils";

export default {
  name: "TripCardList",
  components: {
    MetaTime,
    PaginationComponent,
  },
  computed: {
    tripStore() {
      return useTripStore();
    },
    trips() {
      return this.tripStore.trips;
    },
    currentRouteQuery() {
      return this.$route.query;
    },
  },
  methods: {
    formatDateAndTime,

    formatDriverName(driver) {
      const parts = [];
      if (driver.last_name) parts.push(driver.last_name);
      if (driver.first_name) parts.push(driver.first_name);
      if (driver.middle_name) parts.push(driver.middle_name);
      return parts.join(" ");
    },

    getVehicleRole(trip, vehicleId) {
      const tripVehicle = trip.trip_vehicles.find(
        (tv) => tv.vehicle_id === vehicleId
      );
      return tripVehicle
        ? this.translateRole(tripVehicle.role)
        : null;
    },

    getDriverRole(trip, driverId) {
      const tripDriver = trip.trip_drivers.find(
        (td) => td.driver_id === driverId
      );
      return tripDriver ? this.translateRole(tripDriver.role) : null;
    },

    translateRole(role) {
      const roles = {
        tractor: "Основное средство",
        trailer: "Прицеп",
        support: "Поддержка",
        main_driver: "Основной",
        co_driver: "Дополнительный",
      };
      return roles[role] || role;
    },

    goToTripDetails(tripId) {
      this.$router.push({
        name: "TripDetails",
        params: { id: tripId },
      });
    },
  },
};
</script>

<style scoped>
.trip-block {
  width: 100%;
}

.trip-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--base-out-indent);
}

.trip-item {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.trip-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.trip-item:hover .trip-card {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.card-header {
  padding: var(--base-in-indent);
}

.card-title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.trip-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--color-dark);
  flex: 1;
}

.title-text {
  color: #666;
  font-weight: 500;
}

.trip-status {
  display: inline-block;
  padding: 8px 16px;
  border-radius: 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  min-width: 120px;
  white-space: nowrap;
}

.card-content {
  padding: 0 var(--base-in-indent);
}

.main-info {
  margin-bottom: var(--base-in-indent);
}

.card-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-dark);
}

.section-count {
  background: #667eea;
  color: #fff;
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 14px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
}

.card-section-content {
  padding: 0;
}

.status-display {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
}

.main-info-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
}

.info-value {
  font-size: 14px;
  color: var(--color-dark);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

.transport-drivers-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--base-in-indent);
}

.entities-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.entity-card {
  background: rgb(240, 240, 240);
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  transition: background-color 0.2s ease;
}

.entity-header {
  margin-bottom: 8px;
}

.entity-role {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  padding: 4px 0;
}

.entity-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.detail-label {
  font-size: 13px;
  color: #666;
  font-weight: 500;
  flex-shrink: 0;
}

.detail-value {
  font-size: 13px;
  color: var(--color-dark);
  font-weight: 500;
  text-align: right;
}

.empty-card {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px;
  color: #999;
  text-align: center;
}

.empty-state svg {
  color: #ccc;
  width: 48px;
  height: 48px;
}

.empty-state span {
  font-size: 14px;
}

.card-footer {
  padding: var(--base-in-indent);
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 16px;
}

@media (min-width: 1201px) {
  .transport-drivers-grid {
    grid-template-columns: 1fr 1fr;
    gap: var(--base-in-indent);
  }

  .card-content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: var(--base-in-indent);
  }

  .main-info {
    margin-bottom: 0;
  }
}

@media (min-width: 768px) and (max-width: 1200px) {
  .trip-title {
    font-size: 16px;
  }

  .trip-status {
    min-width: 110px;
    font-size: 13px;
    padding: 6px 12px;
  }

  .card-section-header {
    margin-bottom: 12px;
  }

  .section-title {
    font-size: 15px;
  }

  .info-label,
  .info-value,
  .detail-label,
  .detail-value {
    font-size: 13px;
  }
}

@media (max-width: 767px) {
  .trip-card {
    border-radius: 8px;
  }

  .card-header,
  .card-content,
  .card-footer {
    padding: 15px;
  }

  .card-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .trip-title {
    font-size: 16px;
    width: 100%;
  }

  .trip-status {
    width: 100%;
    min-width: auto;
    padding: 8px;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .main-info {
    margin-bottom: 0;
  }

  .transport-drivers-grid {
    gap: 15px;
  }

  .card-section-header {
    margin-bottom: 10px;
  }

  .section-icon {
    width: 28px;
    height: 28px;
  }

  .section-title {
    font-size: 15px;
  }

  .section-count {
    font-size: 12px;
    padding: 2px 8px;
  }

  .info-row,
  .main-info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
  }

  .info-label,
  .info-value {
    text-align: left;
    width: 100%;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .detail-label,
  .detail-value {
    text-align: left;
    width: 100%;
    font-size: 12px;
  }

  .entities-list {
    gap: 10px;
  }

  .entity-card {
    padding: 10px;
  }

  .empty-state {
    padding: 15px;
  }

  .empty-state svg {
    width: 36px;
    height: 36px;
  }
}

@media (max-width: 480px) {
  .card-header,
  .card-content,
  .card-footer {
    padding: 12px;
  }

  .trip-title {
    font-size: 15px;
  }

  .trip-status {
    font-size: 12px;
    padding: 6px;
  }

  .section-title {
    font-size: 14px;
  }

  .section-icon {
    width: 24px;
    height: 24px;
  }

  .empty-state svg {
    width: 32px;
    height: 32px;
  }
}
</style>
